import { useSelector } from 'react-redux';
import { AppState } from '../../../../../stateManager/store';

export function useAppAndBranchId() {
	const appId = useSelector((state: AppState) => state.apps.selectedApp.id);

	const currentAppBranch = useSelector(
		(state: AppState) => {
			const selectedAppId = state.apps.selectedApp?.id;
			return state.apps.appBranch?.[selectedAppId] ?? {};
		},
		(left: any, right: any) => left.branchId === right.branchId,
	);

	return [appId, currentAppBranch.branchId];
}
